import Notification from "../../Notification";
import HexCheckbox from "./HexCheckbox";

const InputCheckbox = (props) => {
  const {
    id,
    value,
    label,
    subLabel,
    alertType,
    className,
    checkboxType,
    alertMessage,
    onChangeHandler,
    formatId,
    fieldLabel,
    filterFieldLabel,
    ...restConfigs
  } = props;
  return (
    <div>
      <HexCheckbox
        value={value}
        className={className || ""}
        checkboxProps={{
          ...restConfigs,
          id: formatId(label),
          label,
          onChange: (value) => onChangeHandler(value, id),
        }}
        subLabel={subLabel}
        checkboxType={checkboxType}
      />
      {alertType && value && (
        <Notification type={alertType} message={alertMessage} />
      )}
    </div>
  );
};

export default InputCheckbox;
